import React from 'react'

const Notes = () => {
  return (
    <div></div>
  )
}

export default Notes